// Canonical Instrument colors for canvas-API consumers (Fabric.js, 2D ctx).
// getComputedStyle returns '' for custom properties in jsdom and detached
// nodes; fall back to the canonical values so rendering is deterministic.
const FALLBACKS = {
  '--color-accent': '#2E5CFF',
  '--color-danger': '#C4232B',
  '--color-base': '#FFFFFF',
}

// Print substrate for thumbnail export — artwork-truth, not theme.
export const SHEET_SURFACE_COLOR = 'white'

export function resolveThemeColor(name, element = document.documentElement) {
  const value = getComputedStyle(element).getPropertyValue(name).trim()
  return value || FALLBACKS[name]
}

export function withAlpha(hexColor, alpha) {
  const hex = hexColor.replace('#', '')
  const full = hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex
  const r = parseInt(full.slice(0, 2), 16)
  const g = parseInt(full.slice(2, 4), 16)
  const b = parseInt(full.slice(4, 6), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}
